module.exports = __webpack_public_path__ + "static/media/team1.99741489.png";